/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ degree: NonNullable<unknown> }} Guilt_Degree_LabelInputs */

const en_guilt_degree_label = /** @type {(inputs: Guilt_Degree_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.degree === "third_party") return /** @type {LocalizedString} */ (`Third party`);
	if (i?.degree === "concurrent") return /** @type {LocalizedString} */ (`Concurrent`);
	if (i?.degree === "claimant") return /** @type {LocalizedString} */ (`Claimant`);
	return /** @type {LocalizedString} */ (`${i?.degree}`)
	
};

const pt_br2_guilt_degree_label = /** @type {(inputs: Guilt_Degree_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.degree === "third_party") return /** @type {LocalizedString} */ (`Terceiro`);
	if (i?.degree === "concurrent") return /** @type {LocalizedString} */ (`Concorrente`);
	if (i?.degree === "claimant") return /** @type {LocalizedString} */ (`Requerente`);
	return /** @type {LocalizedString} */ (`${i?.degree}`)
	
};

/**
* | degree | output |
* | --- | --- |
* | "third_party" | "Third party" |
* | "concurrent" | "Concurrent" |
* | "claimant" | "Claimant" |
* | * | "{degree}" |
*
* @param {Guilt_Degree_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const guilt_degree_label = /** @type {((inputs: Guilt_Degree_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guilt_Degree_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guilt_degree_label(inputs)
	return pt_br2_guilt_degree_label(inputs)
});